import { Request } from '../utils/http'

export default abstract class ServiceBase {
  protected readonly request: Request

  constructor(request: Request) {
    this.request = request
  }
}
